"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Context = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Context = /*#__PURE__*/(0, _react.createContext)();
exports.Context = Context;

var ItemSelectContext = function ItemSelectContext(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      askForConfirmation = _ref.askForConfirmation,
      beforeChange = _ref.beforeChange,
      parentRef = _ref.parentRef;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      currentItem = _useState2[0],
      setCurrentItem = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      beforeState = _useState4[0],
      setBeforeState = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      common = _useState6[0],
      setCommon = _useState6[1];

  (0, _react.useEffect)(function () {
    onChange(currentItem);
  }, [currentItem]);
  (0, _react.useEffect)(function () {
    if (askForConfirmation && beforeState !== -1) {
      setTimeout(function () {
        return beforeChange(beforeState);
      }, 150); //da tiempo de setear ref
    }
  }, [beforeState]);
  (0, _react.useEffect)(function () {
    if (parentRef) {
      parentRef.current = {
        allowChange: function allowChange() {
          return setCurrentItem(beforeState);
        },
        denyChange: function denyChange() {
          return setBeforeState(-1);
        },
        forceChange: function forceChange(item) {
          return askForConfirmation ? setBeforeState(item) : setCurrentItem(item);
        }
      };
      return function () {
        parentRef.current = null;
      };
    }
  });
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: [currentItem, setCurrentItem, askForConfirmation, setBeforeState, common, setCommon]
  }, children);
};

ItemSelectContext.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  askForConfirmation: _propTypes["default"].bool,
  beforeChange: _propTypes["default"].func,
  parentRef: _propTypes["default"].any
};
ItemSelectContext.defaultProps = {
  onChange: function onChange() {
    return console.warn('no function was assigned as prop');
  },
  askForConfirmation: false,
  beforeChange: function beforeChange() {},
  parentRef: null
};
var _default = ItemSelectContext;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/hooks/itemSelect/ItemSelectContext.js
// module id = 425
// module chunks = 0